import { FormStage } from '../FormStage';
import Header from './components/Header';
import Wrapper from './components/Wrapper';

const ModalParts = {
	Header,
	Stage: FormStage,
	Wrapper,
};

export default ModalParts;
